import React from "react";
import styles from "./index.module.scss";
import type { Transaction } from "@/types/bridge-scanner.types";
import { resolveChainFromId } from "@/utils/resolve-chain.util";
import BlessButton from "@/components/layout/button/green-outline-btn";
import { useParams, useRouter } from "next/navigation";
import TransactionStatus from "@/features/bridge-scanner/components/status";
import CopyableText from "@/features/bridge-scanner/components/copyable-address";
import Chip from "@/features/bridge-scanner/components/type";
import TransactionTimestamp from "@/features/bridge-scanner/components/time";

interface Props {
  tx: Transaction;
}

const TransactionCard = ({ tx }: Props) => {
  const router = useRouter();
  const { network } = useParams() as { network: string };
  const handleGoToTransaction = () => {
    router.push(`/bridge-scanner/${network}/tx/${tx.originTxnHash}`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.detail}>
        <span className={styles.keyName}>Status</span>
        <TransactionStatus status={tx.status} />
      </div>
      <div className={styles.detail}>
        <span className={styles.keyName}>TX Hash</span>
        <CopyableText text={tx.originTxnHash} count={14} hideIcon />
      </div>
      <div className={styles.detail}>
        <span className={styles.keyName}>Type</span>
        <Chip text={tx.type} />
      </div>
      <div className={styles.detail}>
        <span className={styles.keyName}>From</span>
        <CopyableText
          count={10}
          icon={resolveChainFromId(tx.fromChain, tx.network)?.logo}
          text={tx.fromAddress}
        />
      </div>
      <div className={styles.detail}>
        <span className={styles.keyName}>To</span>
        <CopyableText
          count={10}
          icon={resolveChainFromId(tx.toChain, tx.network)?.logo}
          text={tx.toAddress}
        />
      </div>
      <div className={styles.detail}>
        <span className={styles.keyName}>Time</span>
        <div className={styles.time}>
          <TransactionTimestamp timestamp={tx.originTimestamp} />
        </div>
      </div>
      <BlessButton
        onClick={handleGoToTransaction}
        buttonType="outlined"
        color="white"
        styles={{ width: "100%" }}
      >
        View details
      </BlessButton>
    </div>
  );
};

export default TransactionCard;
